import React from "react";

const FLOAT_TEXT = '✨ Generating...';
const SPARK_CHARS = ['✦', '✧', '⋆', '·', '✺'];

export default function WaveText() {
  const items = React.useMemo(() => {
    const chars = FLOAT_TEXT.split('').map((ch) => ({
      type: 'char',
      ch: ch === ' ' ? ' ' : ch,
      style: {
        left: `${5 + Math.random() * 88}%`,
        top: `${20 + Math.random() * 60}%`,
        '--dx1': `${(Math.random() - 0.5) * 14}px`,
        '--dy1': `${(Math.random() - 0.5) * 10}px`,
        '--r1': `${(Math.random() - 0.5) * 18}deg`,
        '--dx2': `${(Math.random() - 0.5) * 12}px`,
        '--dy2': `${(Math.random() - 0.5) * 12}px`,
        '--r2': `${(Math.random() - 0.5) * 15}deg`,
        animationDuration: `${2 + Math.random() * 2.5}s`,
        animationDelay: `-${Math.random() * 3}s`,
      },
    }));
    const sparks = SPARK_CHARS.map((s) => ({
      type: 'spark',
      ch: s,
      style: {
        left: `${5 + Math.random() * 88}%`,
        top: `${10 + Math.random() * 80}%`,
        animationDelay: `-${Math.random() * 2}s`,
        animationDuration: `${1 + Math.random() * 1.5}s`,
        fontSize: `${8 + Math.random() * 8}px`,
      },
    }));
    return [...sparks, ...chars];
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <span className="float-container">
      <span className="float-anchor" aria-hidden="true">{FLOAT_TEXT}</span>
      {items.map(({ type, ch, style }, i) => (
        <span key={i} className={type === 'char' ? 'float-char' : 'magic-spark'} style={style} aria-hidden="true">{ch}</span>
      ))}
    </span>
  );
}
